import { encode } from 'base64-arraybuffer'

import { base64ToBase64Url } from '@cash-web/shared/util-encoding'

export function encodeCredential(credential: PublicKeyCredential & { response: AuthenticatorAttestationResponse }) {
  const encodedRawId = base64ToBase64Url(encode(credential.rawId))
  const encodedAttestationObject = base64ToBase64Url(encode(credential.response.attestationObject))
  const encodedClientDataJson = base64ToBase64Url(encode(credential.response.clientDataJSON))

  const encodedCredential = {
    authenticatorAttachment: credential.authenticatorAttachment,
    id: credential.id,
    rawId: encodedRawId,
    response: {
      attestationObject: encodedAttestationObject,
      clientDataJSON: encodedClientDataJson,
    },
    clientExtensionResults: credential.getClientExtensionResults() || {},
    type: 'public-key',
  }

  return encodedCredential
}
